import {
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@components/ui/dialog'

interface ModalHeaderProps {
  title: string | JSX.Element
  description?: string
}

export default function ModalHeader({
  title,
  description,
}: ModalHeaderProps): JSX.Element {
  return (
    <DialogHeader>
      <DialogTitle className="font-semibold text-large">{title}</DialogTitle>
      {description && <DialogDescription>{description}</DialogDescription>}
    </DialogHeader>
  )
}
